<ng-template #displayTemplateRef
             let-cellData>

  @if (!renderAsText) {
    <p-tag [value]="cellData ? 'Yes' : 'No'"
           [severity]="cellData ? 'success' : 'warn'"
           [rounded]="true"
           i18n-value>
    </p-tag>
  } @else {
    {{ cellData ? 'Yes' : 'No' }}
  }


</ng-template>